import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the api
 */
export class ImportService extends BaseService {

	constructor() {	
		super();
	}
	
	async getImports(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}				
		var data = await this.makeGETRequest('/api/resource/imports' + params);		
		return data;		
	}

	exportImports(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/imports/export' + params);
	}
	
	async getImport(uploadBatchId, companyId) {
		var params = '';
		if (companyId) {
			params = '?companyId=' + companyId;
		}
		var data = await this.makeGETRequest('/api/resource/imports/' + uploadBatchId + params);		
		return data;		
	}
	
	async getImportDetails(uploadBatchId, companyId) {
		var params = '';
		if (companyId) {
			params = '?companyId=' + companyId;
		}		
		var data = await this.makeGETRequest('/api/resource/imports/' + uploadBatchId + '/details' + params);		
		return data;		
	}	
	
	async getImportUnits(uploadBatchId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/imports/' + uploadBatchId + '/units' + params);		
		return data;
	}

	exportImportUnits(uploadBatchId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/imports/' + uploadBatchId + '/units/export' + params);
	}
	
	downloadImport(importIds, companyId) {	
		var params = '?ids='+ importIds;
		if (companyId) {
			params += '&companyId=' + companyId;
		}
		var idList = (importIds || '').split(',').filter(function(id) {
			return id && id.trim().length > 0;
		});
		if (idList.length > 1) {
			return this.submitImportZipDownload(params);
		}
		this.downloadFile('/api/resource/imports/download' + params);				
	};

	/**
	 * Multi-file download builds a zip in the background and returns JSON acceptance.
	 */
	async submitImportZipDownload(params) {
		try {
			var response = await this.performFetch('/api/resource/imports/download' + params, {
				headers: {
					'Accept': 'application/json'
				}
			});
			if (!response.ok) {
				window.DL.MessageUtil.showToastError('Unable to start import zip download (' + response.status + ').');
				return;
			}
			var body = await response.json();
			var message = (body && body.data)
				? body.data
				: 'Import zip is building in the background. You will be notified when it is ready.';
			window.DL.MessageUtil.showToast('Download', message, {
				timeout: 8000,
				theme: 'primary'
			});
			return body;
		} catch (err) {
			window.DL.MessageUtil.showToastError('Unable to start import zip download.');
		}
	};
	
	downloadImportCombine(importIds, companyId) {	
		var params = '?ids='+ importIds;
		if (companyId) {
			params += '&companyId=' + companyId;
		}			
		this.downloadFile('/api/resource/imports/download-combine' + params);				
	};	
	
	async reprocess(uploadBatchId, companyId, options) {
		var params = '';
		if (companyId) {
			params = '?companyId=' + companyId;
		}		
		var data = await this.makePUTRequest('/api/resource/imports/' + uploadBatchId + '/reprocess' + params, options);		
		return data;		
	}	
	
	async rollbackImport(uploadBatchId, companyId, continueOnLock) {
		var params = '';
		if (companyId) {
			params = 'companyId=' + companyId;
		}
		if (continueOnLock) {
			params = '&continueOnLock=' + continueOnLock;
		}
		
		var data = await this.makeDELETERequest('/api/resource/imports/' + uploadBatchId + '/rollback?' + params);		
		return data;		
	}
	
}

